<template>
  <div class="app-logo" v-if="!inApp">
    <a class="logo__link-home" href="/">
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 93 34" ref="svg">
        <polygon points="82,1.3 82,2 85.5,3.3 85.5,26 82,27.3 82,28 93,28 93,27.3 89.4,
          26 89.4,3.3 93,2 93,1.3"
        />
        <path d="M72.6,3.2c1.3,0,4.2,1.4,5.9,5.5h1.2c-0.1-2.1-0.6-5.3-2.2-7.8H77c0,0-0.2,
          1-0.8,0.7s-1.8-1-3.6-1c-4.1,0-7.5,2.8-7.5,7.6v11.1c0,2.4,0.2,4.3,1,5.9c1.3,2.6,3.7,
          4.1,6.6,4.1c3.6,0,6.2-1.8,7.1-5v-3.5c-0.6,0-1.4,0.8-1.4,1.5c-0.4,2.8-1.7,4.4-4.5,
          4.4c-2,0-3.7-1.4-4.5-3.4c-0.5-1.1-0.6-3-0.6-4.5V7.6C68.6,4.7,70.4,3.2,72.6,3.2"
        />
        <path d="M53.8,3.2c1.3,0,4.2,1.4,5.9,5.5h1.2c-0.1-2.1-0.6-5.3-2.2-7.8h-0.6c0,0-0.2,
          1-0.8,0.7s-1.8-1-3.6-1c-4.1,0-7.5,2.8-7.5,7.6v11.1c0,2.4,0.2,4.3,1,5.9c1.3,2.6,
          3.7,4.1,6.6,4.1c3.6,0,6.2-1.8,7.1-5v-3.5c-0.6,0-1.4,0.8-1.4,1.5c-0.4,2.8-1.7,
          4.4-4.5,4.4c-2,0-3.7-1.4-4.5-3.4c-0.5-1.1-0.6-3-0.6-4.5V7.6C49.7,4.7,51.5,3.2,53.8,3.2"
        />
        <path d="M33.5,1.9l2.9,1.3v19.6c0,2.1-1.3,3.8-3.8,3.8c-2.8,0-3.9-1.7-3.9-3.8V3.3l3-1.3
          V1.2H22v0.7l3,1.3v18.6c0,4.1,2.5,7.4,7.3,7.4s7.3-3.3,7.3-7.4V3.3l3-1.3V1.2h-9.2v0.7H33.5z"
        />
        <path d="M8.4,15.9l3.7,1.6v6.4c0,1.4-1,2.7-2.6,2.7c-4.3,0-4.9-5.2-4.9-11.7S5.5,3.2,9.8,
          3.2c2.7,0,4.5,3.2,5.4,5.5h1.3c-0.1-2.1-0.6-5.3-2.2-7.8h-0.6c0,0-0.2,1-0.8,0.7s-1.7-1-3.4-1
          C3.8,0.7,0,6.6,0,14.9s2.9,14.2,9.1,14.2c1.5,0,3.6-0.7,4.3-1.8c0.7,2.7,2.1,4.7,3.9,6c0.5,0.3,
          0.9,0.2,1.2-0.1c0.3-0.3,0.3-0.8-0.1-1.2C17,30.4,16,27.5,16,25.6v-8l3.9-1.7v-0.7H8.4V15.9z"
        />
      </svg>
    </a>
  </div>
</template>

<script>
import anime from '@/assets/libs/anime';
import { inApp } from '@/scripts/utils';

export default {
  name: 'AppLogo',

  data() {
    return {
      inApp: inApp(),
    };
  },

  mounted() {
    if (window.innerWidth >= 768) {
      anime.set(this.$refs.svg, { opacity: 0 });
    } else {
      anime({
        targets: this.$refs.svg,
        translateY: [50, 0],
        opacity: [0, 1],
        easing: 'cubicBezier(.5,0,0,1)',
        duration: 1800,
      });
    }

    this.logoChangesHandler = (type, delay = 0) => {
      if (type === 'show') this.showLogo(delay);
      else this.hideLogo();
    };
    this.$eventHub.$on('logoChanges', this.logoChangesHandler);
    this.$eventHub.$on('windowResize', this.checkColor);
  },

  methods: {
    showLogo(delay) {
      let animation;

      if (window.innerWidth >= 768) {
        animation = anime({
          targets: this.$refs.svg,
          opacity: [0, 1],
          translateY: [50, 0],
          easing: 'cubicBezier(.5,0,0,1)',
          duration: 1800,
          delay: delay + 800,
        });
      } else {
        animation = anime({
          targets: this.$refs.svg,
          fill: '#F1E5C0',
          easing: 'cubicBezier(.5,0,0,1)',
          duration: 1800,
          delay: 800,
        });
      }

      return animation;
    },
    hideLogo() {
      let animation;

      if (window.innerWidth >= 768) {
        animation = anime({
          targets: this.$refs.svg,
          opacity: 0,
          translateY: -50,
          easing: 'cubicBezier(.5,0,0,1)',
          duration: 1800,
        });
      } else {
        animation = anime({
          targets: this.$refs.svg,
          fill: '#353432',
          easing: 'cubicBezier(.5,0,0,1)',
          duration: 1800,
        });
      }

      return animation;
    },
    checkColor() {
      if (window.innerWidth < 768 && !this.$store.state.currentGame.gameEnded) {
        anime.set(this.$refs.svg, { fill: '#353432' });
      } else {
        anime.set(this.$refs.svg, { fill: '#F1E5C0' });
      }
    },
  },

  beforeDestroy() {
    this.$eventHub.$off('logoChanges', this.logoChangesHandler);
    this.$eventHub.$off('windowResize', this.checkColor);
  },
};
</script>

<style lang="scss" scoped>
.app-logo {
  position: absolute;
  top: calc(var(--unit-vh) * 0.4);
  right: 50%;
  height: calc(var(--unit-vh) * 0.25);

  transform: translateX(50%);

  a {
    display: block;
    height: inherit;
  }

  svg {
    display: block;
    height: 100%;
    fill: #353432;
  }

  @include mq($until: ipadP) {
    z-index: 105;
  }

  @include mq(ipadP) {
    top: calc(var(--unit-vh) * 0.3);
    right: 0;
    width: calc(var(--unit-vw) * 6);

    transform: none;

    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      fill: #F1E5C0;
    }
  }
}
</style>
